export default __webpack_public_path__ + "static/media/filtersIcon2.c522ec46.svg";